import React from "react";

const More = ({ fill = "#B0B3C7", width = "14px", height = "14px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.20832 6.41668C1.43642 6.41668 0 4.98025 0 3.20832C0 1.43639 1.43642 0 3.20832 0C4.98023 0 6.41665 1.43642 6.41665 3.20832C6.41473 4.97946 4.97946 6.41473 3.20832 6.41668ZM3.20832 1.75C2.40291 1.75 1.75 2.40291 1.75 3.20832C1.75 4.01373 2.40291 4.66665 3.20832 4.66665C4.01373 4.66665 4.66665 4.01373 4.66665 3.20832C4.66665 2.40291 4.01376 1.75 3.20832 1.75Z"
        fill={fill}
      />
      <path
        d="M10.7923 6.41668C9.02041 6.41668 7.58398 4.98025 7.58398 3.20835C7.58398 1.43645 9.02038 0 10.7923 0C12.5642 0 14.0006 1.43642 14.0006 3.20832C13.9987 4.97946 12.5634 6.41473 10.7923 6.41668ZM10.7923 1.75C9.9869 1.75 9.33398 2.40291 9.33398 3.20832C9.33398 4.01373 9.9869 4.66665 10.7923 4.66665C11.5977 4.66665 12.2506 4.01376 12.2506 3.20832C12.2506 2.40289 11.5977 1.75 10.7923 1.75Z"
        fill={fill}
      />
      <path
        d="M3.20832 14.0026C1.43642 14.0026 0 12.5662 0 10.7943C0 9.02236 1.43642 7.58594 3.20832 7.58594C4.98023 7.58594 6.41665 9.02236 6.41665 10.7943C6.41473 12.5654 4.97946 14.0006 3.20832 14.0026ZM3.20832 9.33591C2.40291 9.33591 1.75 9.98882 1.75 10.7943C1.75 11.5997 2.40291 12.2526 3.20832 12.2526C4.01373 12.2526 4.66665 11.5997 4.66665 10.7943C4.66665 9.98885 4.01376 9.33591 3.20832 9.33591Z"
        fill={fill}
      />
      <path
        d="M10.7923 14.0026C9.02041 14.0026 7.58398 12.5662 7.58398 10.7943C7.58398 9.02236 9.02041 7.58594 10.7923 7.58594C12.5642 7.58594 14.0006 9.02233 14.0006 10.7943C13.9987 12.5654 12.5634 14.0006 10.7923 14.0026ZM10.7923 9.33591C9.9869 9.33591 9.33398 9.98882 9.33398 10.7942C9.33398 11.5996 9.98687 12.2526 10.7923 12.2526C11.5977 12.2526 12.2506 11.5997 12.2506 10.7943C12.2506 9.98885 11.5977 9.33591 10.7923 9.33591Z"
        fill={fill}
      />
    </svg>
  );
};

export default More;
